var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScholarshipsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.56rem",
    viewBox: "0 0 45 31.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "graduation-cap-solid",
    d: "M22.485,32a4.974,4.974,0,0,0-1.666.288L1.1,39.411a1.692,1.692,0,0,0,0,3.178l4.071,1.47a11.575,11.575,0,0,0-1.807,6.215V52.25a13.338,13.338,0,0,1-1.568,5.681A18.641,18.641,0,0,1,.211,60.574a1.128,1.128,0,0,0,.626,1.772l4.5,1.125a1.121,1.121,0,0,0,.872-.141,1.1,1.1,0,0,0,.5-.731,18.127,18.127,0,0,0-.148-7.643A15.548,15.548,0,0,0,5.611,52v-1.73a9.337,9.337,0,0,1,1.962-5.73,8.585,8.585,0,0,1,3.459-2.51L22.07,37.7a1.122,1.122,0,1,1,.823,2.088L11.854,44.122A6.454,6.454,0,0,0,9.59,45.64l11.222,4.05a4.96,4.96,0,0,0,3.333,0l19.729-7.1a1.692,1.692,0,0,0,0-3.178L24.152,32.288A4.974,4.974,0,0,0,22.485,32ZM8.985,58.437c0,2.482,6.047,5.062,13.5,5.062s13.5-2.58,13.5-5.062L34.909,48.214l-10,3.614a7.185,7.185,0,0,1-4.851,0l-10-3.614Z",
    transform: "translate(0.015 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarshipsIcon);
export default __webpack_public_path__ + "static/media/scholarships-icon.c933e073d5a13da02b0dab6290453afd.svg";
export { ForwardRef as ReactComponent };